import React from "react";
import Banner6 from "../partials/Banner/Banner6";
import Section1 from "../includes/DIYIdeasForPackage/Section1";
import { Helmet } from "react-helmet";

const DIYIdeasForPackage = ({ devUrl }) => {
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "https://brainbox.company/blogs/diy-ideas-of-package-drop-box",
    },
    headline: "Top 5 DIY ideas for the package drop box to deter porch pirates",
    image: "https://brainbox.company/images/blogs/blog-3.jpeg",
    author: {
      "@type": "Organization",
      name: "Brain Box",
      url: "https://brainbox.company",
    },
    publisher: {
      "@type": "Organization",
      name: "Brain Box",
      logo: {
        "@type": "ImageObject",
        url: "https://brainbox.company/images/logo-b.png",
      },
    },
    datePublished: "2023-03-01",
    dateModified: "2023-03-02",
  };

  const imgPath = "url(" + devUrl + "images/our-team/ourteam-banner.png)";

  const bgColor = "$blue-color";
  const minHeight = "400px";

  return (
    <>
      <Helmet>
        <title>Top 5 DIY ideas for the package drop box</title>
        <meta
          name="description"
          content="Deter porch pirates with these do-it-yourself ideas for the package drop box and secure your parcels."
        />
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
        <link rel="canonical" href="https://brainbox.company/diy-ideas-of-package-drop-box" />
      </Helmet>
      <main>
        <article className="our-team">
          <Banner6
            imgPath={imgPath}
            bgColor={bgColor}
            minHeight={minHeight}
            text1={
              "Top 5 DIY ideas for the package drop box to deter porch pirates"
            }
          />
          <div className="bg-design">
            <Section1 url={devUrl} />
          </div>
        </article>
      </main>
    </>
  );
};

export default React.memo(DIYIdeasForPackage);
